import { loadFromStorage, saveToStorage } from "../utils";
import { Course } from "../components/form/ApplicationForm";

interface CourseDictionary {
  [key: string]: string;
}

const courseLinkMapper: CourseDictionary = {
  "Vue.js 시작하기 - Age of Vue.js":
    "https://www.inflearn.com/course/Age-of-Vuejs?inst=72986832",
  "Vue 3 시작하기": "https://inf.run/FJrY",
  "Vue.js 중급 강좌":
    "https://www.inflearn.com/course/vue-pwa-vue-js-중급?inst=dd3b6c65",
  "Vue 3 중급 - Composition API": "https://inf.run/MZgCg",
  "Vue.js 완벽 가이드": "https://www.inflearn.com/course/vue-js?inst=c76b3a50",
  "Vue.js 끝장내기 - 실무에 필요한 모든 것":
    "https://www.inflearn.com/course/vue-js-끝내기-캡틴판교?inst=2071ec73",
  "프론트엔드 개발자를 위한 웹팩":
    "https://www.inflearn.com/course/프런트엔드-웹팩?inst=747606f7",
  "타입스크립트 입문":
    "https://www.inflearn.com/course/타입스크립트-입문?inst=f1ae9299",
  "실전 프로젝트로 배우는 타입스크립트":
    "https://www.inflearn.com/course/타입스크립트-실전?inst=e5a8f85e",
  "React와 Vue로 배우는 TypeScript 필수 개념": "https://inf.run/fdprC",
  "PWA 시작하기": "https://www.inflearn.com/course/pwa?inst=3404f525",
  "만들면서 배우는 리액트: 컴포넌트 설계와 리팩토링": "https://inf.run/mGBwi",
  "Next.js 시작하기": "https://inf.run/eTqGZ",
  "실전 프론트엔드 테스팅 시작하기": "https://inf.run/ZN6Wr",
};
const defaultCourseLink = "https://www.inflearn.com/instructors/54224/courses";
const applicationSubmitted = loadFromStorage("submitted") === "true";

const store = {
  couponCode: "",
  course: {} as Course,
  submitted: applicationSubmitted || false,
  getCouponCode() {
    return this.couponCode;
  },
  setCouponCode(code: string) {
    this.couponCode = code;
  },
  setCourse(course: Course) {
    this.course = course;
  },
  isCourseSelected() {
    return Object.keys(this.course).length !== 0;
  },
  getCourseLink() {
    return courseLinkMapper[this.course.title] || defaultCourseLink;
  },
  setSubmitted() {
    this.submitted = true;
    saveToStorage("submitted", this.submitted.toString());
  },
  cancelSubmitted() {
    this.submitted = false;
    saveToStorage("submitted", this.submitted.toString());
  },
};

export default store;
